import { FieldErrors } from "react-hook-form";

type FormErrorsProps = {
  errors: FieldErrors;
};

export function FormErrors(props: FormErrorsProps) {
  if (Object.keys(props.errors).length === 0) {
    return null;
  }

  const formatError = (field: string, err: { message?: string }) => `${field}: ${err?.message}`;

  return (
    <div className="error-messages bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mt-4">
      <ul className="list-disc list-inside">
        {Object.entries(props.errors)
          .filter(([_, error]) => !!error)
          .map(([field, error]) => (
            <li key={field} className="text-sm">
              {formatError(field, error!)}
            </li>
          ))}
      </ul>
    </div>
  );
}
